import React from 'react';
import { useMonthlyRotaForm } from '../context/MonthlyRotaContext';

const Step5Notifications = () => {
  const { formData, updateField } = useMonthlyRotaForm();

  const message = formData.notificationMessage || '';

  const notificationOptions = [
    {
      field: 'notifyStaffWhenPublished',
      label: 'Notify staff when rota is published',
    },
    {
      field: 'sendReminderBeforeShift',
      label: 'Send reminder 1 day before shift',
    },
    {
      field: 'includeAssignedChecks',
      label: 'Include assigned checks in notification',
    },
  ];

  return (
    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">

      {/* Section Header */}
      <div className="flex items-center gap-2.5 mb-5">
        <div className="w-7 h-7 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold text-sm">
          5
        </div>

        <div>
          <h2 className="text-md font-bold text-gray-900">
            Notifications
            <span className="text-gray-400 font-medium ml-1">
              (Optional)
            </span>
          </h2>

          <p className="text-[11px] text-gray-400">
            Send rota notifications to staff and remind them of their shifts
            and assigned checks.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        {/* Notification Options */}
        <div className="space-y-3">
          {notificationOptions.map((option) => (
            <label
              key={option.field}
              className="flex items-center gap-2.5 cursor-pointer group"
            >
              <input
                type="checkbox"
                checked={Boolean(formData[option.field])}
                onChange={(e) =>
                  updateField(option.field, e.target.checked)
                }
                className="
                  w-4 h-4
                  rounded
                  border-gray-300
                  text-blue-600
                  focus:ring-blue-500
                  cursor-pointer
                "
              />

              <span className="text-xs font-medium text-gray-700 group-hover:text-gray-900 transition">
                {option.label}
              </span>
            </label>
          ))}
        </div>

        {/* Notification Message */}
        <div>
          <div className="flex items-center justify-between mb-1">
            <label className="block text-[11px] font-semibold text-gray-600">
              Message (optional)
            </label>
          </div>

          <textarea
            rows={4}
            maxLength={250}
            value={message}
            onChange={(e) =>
              updateField('notificationMessage', e.target.value)
            }
            placeholder="e.g. Please check your rota for May. Contact your manager if you have any issues."
            className="
              w-full
              min-h-[82px]
              resize-none
              text-xs
              text-gray-700
              placeholder-gray-300
              p-3
              border
              border-gray-300
              rounded-md
              bg-white
              focus:outline-none
              focus:ring-1
              focus:ring-blue-500
              focus:border-blue-500
              transition
            "
          />

          <div className="flex justify-end mt-1">
            <span
              className={`text-[10px] font-medium ${
                message.length >= 250
                  ? 'text-red-500'
                  : 'text-gray-400'
              }`}
            >
              {message.length}/250
            </span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Step5Notifications;